@if (isAcademyMode) {
<div class="academy-mode-banner">
  <strong>Academy Mode is ON.</strong>
  Data collected in this mode is only available in Academy Mode and will not
  appear in other modes.
</div>
}
@if (isIsdIopMode) {
<div class="isd-iop-mode-banner">
  <strong>ISD &amp; IOP Mode is ON.</strong>
  Data collected in this mode is only available in ISD &amp; IOP Mode and will not
  appear in other modes.
</div>
}

<div class="light-load-banner" *ngIf="lightLoad.isEnabled()">
  Light Load is on — session data only. Instructions, notes, and BIP are skipped to save memory.
  <button type="button" class="light-load-banner-button" (click)="turnOffLightLoad()">Load full data</button>
</div>
<div class="header" [class.academy-mode-active]="isAcademyMode" [class.isd-iop-mode-active]="isIsdIopMode">
  <div class="side-menu-buttons-header">
    <div class="client-name d-flex" id="clientName">
      @if (currentScreen !== 'settings') {
      {{ this.selectedPatient?.FullName }}
      {{
        this.patientSessionService.getPatientSession()?.ServiceID
          ? " - Service #" +
            this.patientSessionService.getPatientSession()?.ServiceID
          : ""
      }}
      <div
        class="offline-status ms-2"
        *ngIf="
          selectedPatient?.ID && !this.offlineDataService.isInOfflineMode()
        "
      >
        <button
          pButton
          pRipple
          type="button"
          [icon]="isDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
          (click)="downloadPatientProfile()"
          class="p-button-rounded p-button-outlined p-button-info"
          [pTooltip]="getDownloadTooltip()"
          tooltipPosition="bottom"
          [loading]="isDownloading"
        ></button>
      </div>

      <div class="offline-status ms-2 gap-0 flex-column align-items-center">
        @if (areThereUnsyncedData) {
        <small class="text-danger" style="font-size: 16px; font-weight: 500">{{
          isSyncing ? "Syncing..." : "You have un-synced data"
        }}</small>
        } @if (lastDownloadDate) {
        <small class="text-muted"
          >Last downloaded: {{ lastDownloadDate | date : "short" }}</small
        >
        }
      </div>

      <div
        class="offline-status ms-2"
        *ngIf="areThereUnsyncedData"
      >
        <button
          pButton
          pRipple
          type="button"
          [icon]="isSyncing ? 'pi pi-spin pi-spinner' : 'pi pi-sync'"
          (click)="syncPatientData()"
          class="p-button-rounded p-button-outlined p-button-info bg-danger text-white"
          [pTooltip]="getSyncTooltip()"
          tooltipPosition="bottom"
          [loading]="isSyncing"
        ></button>
      </div>

      } @if ( this.offlineDataService.isInOfflineMode()) {
      <span class="text-danger">Offline</span>
      } @if (currentScreen === 'staff-preview') {
      <span class="text-danger">Preview</span>
      }
    </div>
  </div>
  <div class="top-bar-actions" (clickOutside)="clickOutside()" [additionalElementRefs]="[]">
    <button
      class="side-menu-button2 me-3"
      (click)="openMenu = true"
      id="sideMenuButton"
    >
      Menu
      <span *ngIf="hasUpdateAvailable" class="menu-alert-dot" aria-hidden="true"></span>
    </button>
    <div
      class="side-menu-buttons menu-top"
      [class.academy-mode-active]="isAcademyMode"
      [class.isd-iop-mode-active]="isIsdIopMode"
      *ngIf="openMenu"
      id="sideMenuButtons"
    >
      <div
        class="top-bar-meta text-muted small px-2 py-1 w-100 d-flex align-items-center justify-content-between flex-wrap"
      >
        <span *ngIf="loggedInUsername" class="logged-as-block">
          <span class="d-block">Logged as:</span>
          <span class="d-block">{{ loggedInUsername }}</span>
        </span>
        <a
          href="javascript:void(0)"
          class="send-logs-link"
          (click)="sendLogs()"
          id="sendLogsLink"
          >Send logs</a
        >
      </div>
      <button
        *ngIf="hasAcademyModePermission()"
        type="button"
        (click)="toggleAcademyMode()"
        class="academy-mode-toggle-button"
        [class.is-on]="isAcademyMode"
        style="width: 100%"
      >
        <span class="academy-mode-toggle-track" aria-hidden="true">
          <span class="academy-mode-toggle-thumb"></span>
        </span>
        <span class="academy-mode-toggle-label">Academy Mode</span>
        <span class="academy-mode-toggle-state">{{
          isAcademyMode ? "ON" : "OFF"
        }}</span>
      </button>
      <button
        *ngIf="hasIsdIopModePermission()"
        type="button"
        (click)="toggleIsdIopMode()"
        class="isd-iop-mode-toggle-button"
        [class.is-on]="isIsdIopMode"
        style="width: 100%"
      >
        <span class="academy-mode-toggle-track" aria-hidden="true">
          <span class="academy-mode-toggle-thumb"></span>
        </span>
        <span class="academy-mode-toggle-label">ISD &amp; IOP Mode</span>
        <span class="academy-mode-toggle-state">{{
          isIsdIopMode ? "ON" : "OFF"
        }}</span>
      </button>
      @if (!this.offlineDataService.isInOfflineMode()) {
      <div class="text-center w-100" id="selectedPatientDropdown">
        <span *ngIf="patientOptions && patientOptions.length > 0">
          <p-dropdown
            styleClass="w-100 patient-select-dropdown"
            panelStyleClass="patient-select-dropdown-panel"
            appendTo="body"
            autoWidth="false"
            [style]="{ width: '100%' }"
            [options]="patientOptions"
            [ngModel]="selectedPatient?.ID"
            name="selectedPatientDropdown"
            id="selectedPatientDropdown"
            placeholder="Select a patient"
            [filter]="true"
            filterBy="searchString"
            optionLabel="FullName"
            optionValue="ID"
            [virtualScroll]="true"
            [virtualScrollItemSize]="50"
            (onChange)="changedPatient($event)"
          >
            <ng-template pTemplate="selectedItem" let-selectedOption>
              <div class="flex align-items-center gap-2">
                <div>{{ selectedOption.FullName }}</div>
              </div>
            </ng-template>
          </p-dropdown>
        </span>
      </div>
      <button
        *ngIf="showSessionSyncButton"
        id="sessionSyncButton"
        class="session-sync-button"
        [class.active]="sessionSyncRunning"
        [title]="sessionSyncRunning ? 'Stop 2:1 session sync' : 'Start 2:1 session sync'"
        (click)="sessionSyncToggle.emit()"
      >
        <i class="pi pi-link"></i>
        <span>{{ sessionSyncRunning ? 'Stop 2:1 session sync' : 'Start 2:1 session sync' }}</span>
      </button>
      <!-- Staff section - show if user has staff permissions -->
      <ng-container *ngIf="hasStaffPermission()">
        <button
          (click)="switchToStaff()"
          *ngIf="
            this.patientSessionService.getPatientSession()?.ID &&
            this.patientSessionService.getPatientSession()?.ID !== -1 &&
            this.patientSessionService.getPatientSession()?.StaffID ==
              this.loggedUserID
          "
          [class.side-menu-button2]="currentScreen !== 'staff-home'"
          [class.updates-button]="currentScreen === 'staff-home'"
          style="line-height: 16px; width: 100%"
        >
          Session<br />
          <small
            style="font-size: 12px"
            *ngIf="this.patientSessionService.getPatientSession()?.ServiceID"
            >Service #{{
              this.patientSessionService.getPatientSession()?.ServiceID
            }}</small
          >
        </button>

        <button
          (click)="switchToSessionList()"
          id="allSessionsButton"
          [class.side-menu-button2]="currentScreen !== 'staff-sessions'"
          [class.updates-button]="currentScreen === 'staff-sessions'"
          *ngIf="selectedPatient"
          style="width: 100%"
        >
          All Sessions
        </button>
      </ng-container>

      <!-- Supervisor section - show if user has supervisor permissions -->
      <button
        (click)="switchToSupervisor()"
        id="supervisorButton"
        [class.side-menu-button2]="currentScreen !== 'supervisor'"
        [class.updates-button]="currentScreen === 'supervisor'"
        style="width: 100%"
        *ngIf="selectedPatient && hasSupervisorPermission()"
      >
        Supervisor
      </button>

      <!-- Graphs section - show if user has graphs permissions -->
      <button
        id="graphsButton"
        *ngIf="selectedPatient && hasGraphsPermission()"
        style="width: 100%"
        [routerLink]="['/graphs', selectedPatient.ID]"
        [queryParams]="getAcademyModeQueryParams()"
        [class.side-menu-button2]="currentScreen !== 'graphs'"
        [class.updates-button]="currentScreen === 'graphs'"
      >
        Graphs
      </button>
      }

      <hr />

      <button
        id="offlinePatientsButton"
        [routerLink]="['/offline']"
        [class.side-menu-button2]="currentScreen !== 'offline'"
        [class.updates-button]="currentScreen === 'offline'"
        style="min-width: 100%"
      >
        Offline Patients
      </button>

      <button
        *ngIf="lightLoad.isEnabled()"
        (click)="turnOffLightLoad()"
        class="side-menu-button2"
        id="turnOffLightLoadButton"
        style="width: 100%"
      >
        Load full Spark data
      </button>

      @if (!this.offlineDataService.isInOfflineMode()) {
      <!-- Settings section - show if user has settings permissions -->
      <button
        [routerLink]="['/settings/prompt-codes']"
        [class.side-menu-button2]="currentScreen !== 'settings'"
        [class.updates-button]="currentScreen === 'settings'"
        id="settingsButton"
        style="width: 100%"
        *ngIf="hasSettingsPermission()"
      >
        General Settings
      </button>
      <button
        (click)="backToOpto()"
        class="side-menu-button2"
        id="backToOptoButton"
        style="width: 100%"
      >
        Back to Opto
      </button>
      <button
        (click)="signOut()"
        class="side-menu-button2"
        id="signOutButton"
        style="width: 100%"
      >
        Sign Out
      </button>
      <button
        *ngIf="isInstallable"
        (click)="installApp()"
        class="side-menu-button2 install-menu-button"
        id="installAppButton"
        style="width: 100%"
      >
        Install App
      </button>
      <div
        class="update-status-container"
        [class.update-status-compact]="!hasUpdateAvailable"
      >
        <button
          *ngIf="hasUpdateAvailable"
          (click)="updateApp()"
          class="side-menu-button2 update-menu-button"
          id="updateAppButton"
          style="width: 100%"
          [disabled]="isApplyingUpdate"
        >
          {{ isApplyingUpdate ? "Updating..." : "Update App (Available)" }}
        </button>
        <small *ngIf="!hasUpdateAvailable" class="update-status-label">
          Running latest version
        </small>
      </div>
      }
    </div>
  </div>
</div>
